module.exports = __webpack_public_path__ + "img/catagory1.79a617d0.jpg";